const accHD = document.querySelectorAll('.accordionItem__wrapper');

if(typeof(accHD) != 'undefined' && accHD != null && accHD.length!==0){
    accHD.forEach(el => {
        el.addEventListener('click', event => {
            event.preventDefault();
            const el_siblings = el.closest('.accordionWrapper').querySelectorAll('.accordionItem');
            el_siblings.forEach(s => {
                if (s.classList.contains('open')) {
                    s.classList.remove('open');
                    s.classList.add('close');
                }
            });

            if (el.parentNode.classList.contains('close')) {
                el.parentNode.classList.remove('close');
            }
            el.parentNode.classList.add('open');

        });
    });
}

let moreButton = document.querySelector('.about-more_button');
let moreText = document.querySelector('.about-more_text');
if (!!moreButton && !!moreText) {
    document.addEventListener('click', function (e) {
            if (e.target.classList.contains('about-more_button') && e.target.classList.contains('active')) {
                moreButton.classList.remove('active');
                moreButton.textContent = moreButton.getAttribute('data-text1');
                moreText.classList.remove('active');
            } else if(e.target.classList.contains('about-more_button')){
                moreButton.classList.add('active');
                moreButton.textContent = moreButton.getAttribute('data-text2');
                moreText.classList.add('active');
            }
    });
}
